import React, { Component } from 'react';
import { get } from 'lodash';
import ImagePreview from 'components/shared/ImagePreview';
import InfoTooltip from 'components/shared/InfoTooltip';
import request from 'utils/request_ajax';
import { hasFeatureFlags } from 'utils/features';
import { routes } from 'constants/config';
import fileStackImageUpload from 'misc/imageUpload';
import { UniversalUploader } from 'components/shared/UniversalUploader';
import ImageLibraryPicker from 'components/shared/ImageLibraryPicker';
import ImageLibraryAddDialog from 'components/shared/ImageLibraryAddDialog';

const LinkButton = props => (
  <button type="button" className="u-linkBtn ws-nw" {...props} />
);

class TagImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: props.tag.image,
      addToLibraryVisible: false,
      hasFileUploadFF: hasFeatureFlags([
        'learning-file-stack-upload-replacement',
      ]),
      universalUploaderModalVisible: false,
    };
    this.handleUploadImage = this.handleUploadImage.bind(this);
    this.saveBssUpload = this.saveBssUpload.bind(this);
    this.handleRemoveImage = this.handleRemoveImage.bind(this);
    this.toggleImageLibrary = this.toggleImageLibrary.bind(this);
    this.handleImageLibrarySelect = this.handleImageLibrarySelect.bind(this);
    this.toggleAddToLibrary = this.toggleAddToLibrary.bind(this);
  }

  get imageId() {
    return get(this.state.image, 'id', '');
  }

  closeUniversalUploaderModal = () => {
    if (this.state.universalUploaderModalVisible) {
      this.setState({ universalUploaderModalVisible: false });
    }
  };

  toggleUniversalUploader = () => {
    this.setState(state => ({
      universalUploaderModalVisible: !state.universalUploaderModalVisible,
    }));
  };

  handleImageLibrarySelect(selectedImage) {
    request
      .post(routes.ASSOCIATED_IMAGES, {
        content_id: this.props.tag.id,
        content_type: this.props.content_type,
        image_type: this.props.image_type,
        image_id: selectedImage.id,
      })
      .then(image => {
        this.setState({
          image,
          viewImageLibrary: false,
        });
      });
  }

  handleUploadImage() {
    const associatedImageParams = {
      content_id: this.props.tag.id,
      content_type: this.props.content_type,
      image_type: this.props.image_type,
    };

    if (this.state.hasFileUploadFF) {
      this.toggleUniversalUploader();
    } else {
      fileStackImageUpload(associatedImageParams)
        .then(image => {
          this.setState({ image });
          this.toggleAddToLibrary();
        })
        .catch(e => {
          console.error(e);
          if (this.state.addToLibraryVisible) {
            this.toggleAddToLibrary();
          }
        });
    }
  }

  saveBssUpload(newUpload) {
    return new Promise(async (resolve, reject) => {
      const { bssUploadId } = newUpload;

      try {
        const uploadImage = await request.postJSON(routes.IMAGES, {
          image: {
            bss_upload_id: bssUploadId,
            content_id: this.props.tag.id,
            content_type: this.props.content_type,
            image_type: this.props.image_type,
          },
        });
        this.setState({ image: uploadImage });
        this.closeUniversalUploaderModal();
        this.toggleAddToLibrary();
        resolve();
      } catch (e) {
        reject(new Error(e));
      }
    });
  }

  handleRemoveImage() {
    const associatedImageParams = {
      image: {
        content_id: this.props.tag.id,
        content_type: this.props.content_type,
        image_type: this.props.image_type,
      },
    };

    request
      .delete(routes.IMAGE(this.state.image.id), associatedImageParams)
      .then(() => {
        this.setState({ image: null });
      });
  }

  toggleImageLibrary() {
    this.setState(state => ({ viewImageLibrary: !state.viewImageLibrary }));
  }

  toggleAddToLibrary() {
    this.setState(state => ({
      addToLibraryVisible: !state.addToLibraryVisible,
    }));
  }

  render() {
    return (
      <div className="TagImage">
        {this.state.image && (
          <div>
            <ImagePreview image={this.state.image} className="mr-8" />
            <LinkButton children="Remove" onClick={this.handleRemoveImage} />
          </div>
        )}
        {!this.state.image && (
          <LinkButton children="Upload" onClick={this.handleUploadImage} />
        )}
        {!this.state.image && this.props.uploadTooltip && (
          <InfoTooltip className="ml-4" tooltip={this.props.uploadTooltip} />
        )}
        {!this.state.image && this.props.allowImageLibrary && (
          <LinkButton
            children={I18n.t('image_library.select_from_library')}
            onClick={this.toggleImageLibrary}
          />
        )}

        {this.state.viewImageLibrary && (
          <ImageLibraryPicker
            onSelect={this.handleImageLibrarySelect}
            onDismiss={this.toggleImageLibrary}
          />
        )}
        <input name="tag[image_id]" value={this.imageId} readOnly hidden />

        {this.state.universalUploaderModalVisible && (
          <UniversalUploader
            accept={['image/*']}
            displayInModal
            modalShown={this.state.universalUploaderModalVisible}
            onModalDismiss={this.closeUniversalUploaderModal}
            onComplete={this.saveBssUpload}
            helperText={t('universal_uploader.image_library_helper')}
            deleteUploadRecord={false}
          />
        )}
        <ImageLibraryAddDialog
          canManageContentLibrary={
            this.props.meta.permissions.can_manage_content_library
          }
          image={this.state.image}
          visible={this.state.addToLibraryVisible}
          toggleVisible={this.toggleAddToLibrary}
        />
      </div>
    );
  }
}

export default TagImage;
